import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import {Trans} from '@common/i18n/trans';
import {useForm} from 'react-hook-form';
import {CrupdateResourceLayout} from '@common/admin/crupdate-resource-layout';
import {useChat} from '../requests/use-chat';
import {Chat} from '../../../chats/chat';
import {CrupdateChatForm} from './crupdate-chat-form';
import {
  UpdateChatPayload,
  useUpdateChat,
} from '../requests/use-update-chat';
import moment from 'moment-timezone';

interface CreateChatProps {
  callback_url: string;
}

export function EditChatPage({callback_url}: CreateChatProps) {
  const query = useChat();

  if (query.status !== 'success') {
    return <FullPageLoader />;
  }

  return <PageContent  chat={query.data. chat} callback_url={callback_url}/>;
}

interface PageContentProps {
   chat: Chat;
   callback_url: string;
}
function PageContent({ chat, callback_url}: PageContentProps) {
  const form = useForm<UpdateChatPayload>({
    defaultValues: {
      ... chat,
    },
  });
  const updateChat = useUpdateChat(form, callback_url);

  return (
    <CrupdateResourceLayout
      form={form}
      onSubmit={values => {
        updateChat.mutate(values);
      }}
      title={
        <Trans message="Edit :name chat" values={{name:  (chat.name)}} />
      }
      isLoading={updateChat.isPending}
    >
      <CrupdateChatForm />
    </CrupdateResourceLayout>
  );
}
